module.exports = __webpack_public_path__ + "static/media/bi6.e24f5503.png";